import { render, staticRenderFns } from "./ServiceRequests.vue?vue&type=template&id=39a6b956&scoped=true&"
import script from "./ServiceRequests.vue?vue&type=script&lang=js&"
export * from "./ServiceRequests.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRequests.vue?vue&type=style&index=0&id=39a6b956&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a6b956",
  null
  
)

export default component.exports